import { FC } from "react";
import { Stack } from "@mui/material";
import { ViewCostTypeSelect } from "@/components/pages/resource-explorer/components/settings-panel/components/cost-type-settings-section/ViewCostTypeSelect";

export const TotalCostVariants: FC = () => {
  return (
    <Stack alignItems="flex-end">
      <ViewCostTypeSelect variant="dropDown" />
    </Stack>
  );
};
